import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "outerLine"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_gpickr = _resolveComponent("gpickr");
  const _component_slider_input = _resolveComponent("slider-input");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  return _openBlock(), _createElementBlock("ul", _hoisted_1, [_createElementVNode("li", null, [_createVNode(_component_gpickr, {
    title: "颜色",
    color: $data.form.color,
    onColor: _cache[0] || (_cache[0] = $event => $options.drawLineChange($event, 'color'))
  }, null, 8, ["color"])]), _createElementVNode("li", null, [_createVNode(_component_slider_input, {
    title: "粗细",
    min: 1,
    max: 20,
    size: $data.form.width,
    onInput: _cache[1] || (_cache[1] = $event => $options.drawLineChange($event, 'width'))
  }, null, 8, ["size"])]), _createElementVNode("li", null, [_cache[4] || (_cache[4] = _createElementVNode("span", null, "样式", -1)), _createVNode(_component_el_select, {
    modelValue: $data.form.linetype,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.linetype = $event),
    class: "m-2 borderstyle",
    placeholder: "请选择",
    onChange: _cache[3] || (_cache[3] = $event => $options.drawLineChange($event, 'type'))
  }, {
    default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (item, index) => {
      return _createVNode(_component_el_option, {
        key: index,
        value: item
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(["solidIcon", `icon${index + 1}`])
        }, null, 2)]),
        _: 2
      }, 1032, ["value"]);
    }), 64))]),
    _: 1
  }, 8, ["modelValue"])])]);
}